import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {WorkingTimeSchemaComponent} from './working-time-schema.component';
import {SharedModule} from '../../shared/shared.module';
import {WorkingTimeSchemaService} from './working-time-schema.service';
import { WorkingTimeSchemaViewerComponent } from './working-time-schema-viewer/working-time-schema-viewer.component';
import { WorkingTimeSchemaModalComponent } from './working-time-schema-modal/working-time-schema-modal.component';
import { WorkingTimeSchemaFiltersComponent } from './working-time-schema-filters/working-time-schema-filters.component';
import { WorkingTimeSchemaTableComponent } from './working-time-schema-table/working-time-schema-table.component';
import { WorkingTimeSchemaPopupComponent } from './working-time-schema-popup/working-time-schema-popup.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}

@NgModule({
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    SharedModule,
    CommonModule,
    FormsModule
  ],
  declarations: [
    WorkingTimeSchemaComponent,
    WorkingTimeSchemaViewerComponent,
    WorkingTimeSchemaModalComponent,
    WorkingTimeSchemaFiltersComponent,
    WorkingTimeSchemaPopupComponent,
    WorkingTimeSchemaTableComponent
  ],
  exports: [
    WorkingTimeSchemaComponent
  ],
  providers: [WorkingTimeSchemaService]
})
export class WorkingTimeSchemaModule { }
